import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.Form,
  title: 'Form',
  category: ComponentCategory.FormControls,
  droppable: true,
};
